import React, { Component } from "react"
import Link from "gatsby-link"
import PostIntro from "../components/Linking/postIntro"
import PostFilter from "../components/Linking/postFilter"
import BlogListAside from "../components/Containers/blogListAside"
import Helmet from "react-helmet"

 
const NavLink = props => {
  if (!props.test) {
    return <Link to={props.url}>{props.text}</Link>;
  } else {
    return <span>{props.text}</span>;
  }
};
 
const IndexPage = ({ data, pathContext }) => {
  const { group, index, first, last, pageCount, pathPrefix } = pathContext;
  const previousUrl = index - 1 == 1 ? "/blog/" : (index - 1).toString();
  const nextUrl = (index + 1).toString();

 
  return (
  <div>

    <Helmet>
        <meta name="description" content="Aprende diseño y desarrollo web. Encuentra tutoriales y reviews de libros sobre diseño, programación y emprendizaje." />
        <title>Diseño y desarrollo web (tutoriales, libros y más) | @gmugart</title>
    </Helmet>
      

     <PostFilter borders={true} filterText={"Filtrar:"} />
     <div className="blog-list-container">
        {group.map(({ node }) => (
        <div key={node.id}>     
        <BlogListAside category={node.frontmatter.category} date={node.frontmatter.date}/>
          <div className="blogListing">
            <PostIntro key={node.id} post={node} />
          </div>
        </div> 
        ))}
      </div>

     <div className="previousLink">
        <NavLink test={first} url={previousUrl} text="&#x2190; Página anterior" />
      </div>
      <div className="nextLink">
        <NavLink test={last} url={nextUrl} text="Siguiente página &#x2192;" />
      </div>
  </div>
  );
  
};

export default IndexPage;
/*
export const pageQuery = graphql`
  query BlogPostForListingByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "YYYY-MM-DD")
        path
        category
        title
        tags
      }
    }
  }
`;*/


// WEBPACK FOOTER //
// ./src/templates/blogListTemplate.js